import { render } from "./ModalAdicionarLubrificante.vue?vue&type=template&id=5180829e&scoped=true&ts=true"
import script from "./ModalAdicionarLubrificante.vue?vue&type=script&lang=ts"
export * from "./ModalAdicionarLubrificante.vue?vue&type=script&lang=ts"

import "./ModalAdicionarLubrificante.vue?vue&type=style&index=0&id=5180829e&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5180829e"]])

export default __exports__